import { makeStyles } from 'tss-react/mui';
import { addWidthInner, widthOuter } from '../../styles/jss/utils';
import { colors, spacing } from '../../styles/jss/variables';
// Need to get back jss-to-tss-react codemod: Unable to handle style definition reliably. Unsupported arrow function syntax.
//Unexpected value type of CallExpression.
const useStyles = makeStyles()((theme, _params, classes) => ({
    mainContent: {
        overflowX: 'hidden',
        flexGrow: 1,
        backgroundColor: colors.supplementary.white,
        minHeight: '100vh',
        [theme.breakpoints.up('md')]: Object.assign({}, widthOuter),
        ['& [data-loading] ~  div']: {
            visibility: 'hidden',
        },
    },
    componentContainer: {
        width: '100%',
        paddingBottom: theme.isFlyingFlowers ? spacing.medium : spacing.small,
        paddingLeft: theme.isFlyingFlowers ? spacing.small : spacing.xs,
        paddingRight: theme.isFlyingFlowers ? spacing.small : spacing.xs,
        [theme.breakpoints.up('md')]: {
            paddingBottom: theme.isFlyingFlowers ? spacing.xl : spacing.small,
            paddingLeft: theme.isFlyingFlowers ? spacing.large : spacing.small,
            paddingRight: theme.isFlyingFlowers ? spacing.large : spacing.small,
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: `${theme.breakpoints.values.xl}px`,
        },
    },
    floatingButtonNoPadding: addWidthInner(theme, {
        padding: 0,
    }),
    floatingButtonPdpV2Offset: {
        '& button': {
            [theme.breakpoints.up('md')]: {
                marginTop: '-54px',
            },
        },
    },
    topSpacing: {
        paddingTop: spacing.medium,
        [theme.breakpoints.up('md')]: {
            paddingTop: spacing.large,
        },
    },
    checkoutTopSpacing: {
        paddingTop: spacing.medium,
    },
    pdpTopSpacing: {
        paddingTop: spacing.medium,
        [theme.breakpoints.up('md')]: {
            paddingTop: spacing.large,
        },
        [theme.breakpoints.down('sm')]: {
            paddingTop: spacing.xs,
        },
    },
    centreContent: {
        [`& .${classes.componentContainer}`]: {
            [theme.breakpoints.up('md')]: {
                maxWidth: '1064px',
            },
        },
    },
    centreContentSmall: {
        [`& .${classes.componentContainer}`]: {
            [theme.breakpoints.up('md')]: {
                maxWidth: '792px',
            },
        },
    },
    centreContentExtraSmall: {
        [`& .${classes.componentContainer}`]: {
            [theme.breakpoints.up('md')]: {
                maxWidth: '520px',
            },
        },
    },
    homeHeroGallerySpacing: {
        paddingTop: `${spacing.xs} !important`,
        [theme.breakpoints.up('md')]: {
            paddingTop: 'initial',
        },
    },
    myAccountTitlePadding: {
        paddingTop: spacing.medium,
        paddingBottom: 0,
        [theme.breakpoints.up('md')]: {
            paddingTop: spacing.xxl,
        },
    },
    myAccountCardPadding: {
        paddingBottom: spacing.small,
    },
    titlePadding: {
        paddingBottom: 0,
    },
    myAccountRemindersPadding: {
        paddingBottom: spacing.small,
    },
    blogCategoryLinkGallery: {
        paddingBottom: spacing.medium,
        [theme.breakpoints.up('md')]: {
            paddingBottom: spacing.large,
        },
    },
    noPadding: {
        padding: 0,
    },
    noVerticalPadding: {
        paddingTop: 0,
        paddingBottom: spacing.small,
    },
}));
export default useStyles;
